import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuthorize } from '../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../models/user-permission-name';

interface ConfirmationDialog {
  onClosed: () => void;
  onContinue: () => void;
}
export const ConfirmationDialog = ({ onContinue, onClosed }: ConfirmationDialog) => {

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth={'sm'}
    // onClose={onClosed}
    >
      <DialogTitle id="scroll-dialog-title">Replace Proctor Result</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <div style={{ padding: '25px 50px', textAlign: 'center' }}>
          <p>Proctor Results currently selected will be replaced. Do you want to continue?</p>
        </div>
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="spaceBetween">
          <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" style={{ width: '100px' }} onClick={onContinue} disabled={isReadOnlyPermission}>
            Save
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
